import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="fixed bottom-0 left-0 right-0 w-full z-40 max-h-[60px] border-t"
      style={{
        background: 'var(--neutral-off-white)',
        borderColor: 'var(--neutral-beige)',
      }}
    >
      <div className="max-w-[1400px] mx-auto px-6 py-2 flex justify-between items-center gap-4 h-full md:flex-row flex-col md:text-left text-center md:gap-4 gap-2 md:px-6 px-4">
        <p className="text-[13px] m-0" style={{ color: 'var(--neutral-grey)' }}>
          &copy; {currentYear} Devyx. Todos os direitos reservados.
        </p>

        <div className="flex gap-4 md:gap-4 gap-3">
          <Link
            to="/terms"
            className="text-[13px] no-underline transition-colors duration-200 hover:text-[var(--primary-orange)] active:text-[var(--primary-purple)]"
            style={{ color: 'var(--neutral-grey)' }}
          >
            Termos de uso
          </Link>
          <Link
            to="/privacy"
            className="text-[13px] no-underline transition-colors duration-200 hover:text-[var(--primary-orange)] active:text-[var(--primary-purple)]"
            style={{ color: 'var(--neutral-grey)' }}
          >
            Políticas de privacidade
          </Link>
          <Link
            to="/help"
            className="text-[13px] no-underline transition-colors duration-200 hover:text-[var(--primary-orange)] active:text-[var(--primary-purple)]"
            style={{ color: 'var(--neutral-grey)' }}
          >
            Ajuda
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
